const targetEl = document.getElementById('cart');
const cartObserver = new MutationObserver(function (mutations) {
  mutations.forEach(function (mutation) {
    if (
      mutation.attributeName === 'class' &&
      mutation.target.classList.contains('toggle')
    ) {
      if (window.runExperiment != 1) {
        window.runExperiment = 1;

        window._conv_q = window._conv_q || [];
        window._conv_q.push(['executeExperiment', '10049207']);

        console.log('Activated Experiment');

        // trigger "opened cart drawer" goal
        _conv_q.push(['triggerConversion', '10048399']);
      }
    }
  });
});
cartObserver.observe(targetEl, { attributes: true });

/**
 * Opened Mobile Menu
 */
const targetmenuEl = document.getElementById('abtestbtn');
const mobilemenuObserver = new MutationObserver(function (mutations) {
  mutations.forEach(function (mutation) {
    if (
      mutation.attributeName === 'class' &&
      mutation.target.classList.contains('is-visible')
    ) {
      if (window.runExperiment != 'mobile-menu') {
        window.runExperiment = 'mobile-menu';

        window._conv_q = window._conv_q || [];
        window._conv_q.push(['executeExperiment', '100412261']);

        console.log('Activated Vertical mobile menu A/B Experiment');

        // trigger "Vertical mobile menu clicked" goal
        _conv_q.push(['triggerConversion', '100411723']);
      }
    }
  });
});
mobilemenuObserver.observe(targetmenuEl, { attributes: true });
